import { RichTextFooterItem } from '@framework/form/inputs/rich-text/RichTextFooterItem.tsx';
import { useWatch } from 'react-hook-form';
import { InfoIcon } from '../../ui/info-icon/InfoIcon.tsx';
import { renderRichTextAdvancedNodes } from './render/renderRichTextAdvancedNodes.tsx';

export interface InfoIconInputPreviewProps {
  name: string;
}

export function InfoIconInputPreview(props: InfoIconInputPreviewProps) {
  const { name } = props;
  const text = useWatch({ name });
  return (
    <RichTextFooterItem>
      Fai click sull’icona{' '}
      <InfoIcon text={renderRichTextAdvancedNodes(text, true)} /> per
      visualizzare l’anteprima
    </RichTextFooterItem>
  );
}
